import { Redirect, Route } from 'react-router-dom';
import React, { PropsWithChildren, Suspense } from 'react';
import { Loading } from '@fides/fides-react-components';

import { useGlobalConfigContext } from '../contexts/GlobalConfig';
import { GlobalConfig } from '../interfaces';

export const PrivateRoute = (props: PropsWithChildren<any>) => {
  const { children, ...otherProps } = props;

  const globalConfig: GlobalConfig = useGlobalConfigContext();

  if (globalConfig.userIsLoggedIn) {
    return (
      <Route {...otherProps}>
        <Suspense fallback={<Loading />}>{children}</Suspense>
      </Route>
    );
  }

  return <Redirect to='/login' />;
};
